<script>
  import { Button } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { downloadDebugReport } from '@client/utils/debug-report';

  /**
   * The error object. Component renders when this is truthy.
   * @type {{ message?: string, stack?: string }}
   * @default undefined
   */
  export let error = undefined;

  /**
   * Report title.
   * @type {string}
   * @default undefined
   */
  export let title = undefined;

  /**
   * Download filename (without extension).
   * @type {string}
   * @default undefined
   */
  export let filename = undefined;

  /**
   * Execution time in ms.
   * @type {number}
   * @default undefined
   */
  export let executionTime = undefined;

  /**
   * API request log entries from APITransport.getRequestLog().
   * @type {Array}
   * @default undefined
   */
  export let requestLogs = undefined;

  /**
   * Key-value pairs for the details section.
   * @type {Object<string, string|number>}
   * @default undefined
   */
  export let details = undefined;

  /**
   * Additional named data sections.
   * @type {Array<{ label: string, data: * }>}
   * @default undefined
   */
  export let sections = undefined;

  const download = () => {
    downloadDebugReport({ title, filename, error, executionTime, requestLogs, details, sections });
  };
</script>

{#if error}
  <Button size="sm" color="danger" outline on:click={download}>
    <Icon name="download" size="14" />
    Debug Report
  </Button>
{/if}
